interface IJWTPayload {
  exp: number
  iat: number
  userId?: string
  [key: string]: any
}

export const decodeJWT = (token: string): IJWTPayload | null => {
  try {
    const parts = token.split(".")
    if (parts.length !== 3) {
      return null
    }

    const payload = parts[1]
    const decoded = atob(payload.replace(/-/g, "+").replace(/_/g, "/"))
    return JSON.parse(decoded)
  } catch (error) {
    console.error("Failed to decode JWT:", error)
    return null
  }
}

export const isTokenExpired = (token: string): boolean => {
  const decoded = decodeJWT(token)
  if (!decoded || !decoded.exp) {
    return true
  }

  // exp в секундах, Date.now() в мілісекундах
  const expirationTime = decoded.exp * 1000
  const currentTime = Date.now()

  // Додаємо 1 хвилину буфер (оновлюємо за 1 хв до expiration)
  const bufferTime = 60 * 1000

  return currentTime >= expirationTime - bufferTime
}

export const getTokenFromStorage = (
  tokenName: "accessToken" | "refreshToken"
): string | null => {
  // AccessToken з sessionStorage, refreshToken з localStorage
  if (tokenName === "accessToken") {
    return sessionStorage.getItem(tokenName)
  }
  return localStorage.getItem(tokenName)
}

export const isTokenValid = (
  tokenName: "accessToken" | "refreshToken"
): boolean => {
  const token = getTokenFromStorage(tokenName)
  if (!token) {
    return false
  }

  return !isTokenExpired(token)
}
